import { render, staticRenderFns } from "./SignInDialog.vue?vue&type=template&id=bb854488"
import script from "./SignInDialog.vue?vue&type=script&lang=js"
export * from "./SignInDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports